<template>
  <div class="mfaActivationField flex-row">
    <F2gIcon
      value="security-1"
      class="icon my-auto mr-2"
      :class="{ mainIconHover: hover }"
      stroke=""
      :strokeWidth="3"
    />
    <v-btn
      class="button button-rounded"
      :class="[buttonStyle, { buttonHover: hover }]"
      @mouseover="hover = true"
      width="160px"
      @mouseleave="hover = false"
      @click="eventButtonActive"
    >
      {{ buttonText }}
    </v-btn>

    <!-- Info Modal -->
    <MfaGooglePopUp
      v-if="showGoogleModal"
      :showModal="showGoogleModal"
      :qrData="mfaGoogleInfo"
      :activeMfa="activeMfa"
      @validateToken="(token) => eventValidateToken(token)"
      @closeModal="showGoogleModal = false"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MfaGooglePopUp from "@/flit2go-web-core/components/ui/mfaGooglePopUp.vue";

export default {
  name: "mfaActivationField",
  components: { MfaGooglePopUp },
  props: {
    activeMfa: { required: true, type: Boolean, default: false },
  },
  data: () => ({
    hover: false,
    validationCode: null,
    showGoogleModal: false,
    mfaGoogleInfo: {},
  }),
  computed: {
    buttonText() {
      return this.activeMfa
        ? this.hover
          ? this.$t("mfa.disableMFA")
          : this.$t("common.MFAenabled")
        : this.hover
        ? this.$t("mfa.enableMFA")
        : this.$t("common.MFAdisabled");
    },
    buttonStyle() {
      return this.activeMfa ? "blueButton" : "redButton";
    },
  },
  methods: {
    ...mapActions({
      enableMFA: "auth/enableMFA",
      disableMFA: "auth/disableMFA",
      validateMFATokenEnabled: "auth/validateMFATokenEnabled",
      validateMFATokenDisabled: "auth/validateMFATokenDisabled",
    }),

    eventButtonActive() {
      if (this.activeMfa) {
        this.showGoogleModal = true;
      } else {
        this.enableMFA().then((resp) => {
          this.mfaGoogleInfo = resp.data;
          this.hover = false;
          this.showGoogleModal = true;
        });
      }
    },
    eventValidateToken(token) {
      let payload = { token: token };
      if (this.activeMfa) {
        this.validateMFATokenDisabled(payload)
          .then((resp) => {
            this.$emit("validatedMfa", resp.data);
            this.validationCode = null;
            this.showGoogleModal = false;
          })
          .catch((err) => {
            this.$emit("error", err.response.data);
          });
      } else {
        this.validateMFATokenEnabled(payload)
          .then((resp) => {
            this.$emit("validatedMfa", resp.data);
            this.validationCode = null;
            this.showGoogleModal = false;
          })
          .catch((err) => {
            this.$emit("error", err.response.data);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.mfaActivationField {
  height: 36px;

  .v-btn {
    margin: 0;
    width: 8rem;
  }

  .input {
    border-bottom: 2px solid $success-f2g;
  }

  .icon {
    height: 24px;
    width: 24px;
    stroke: grey;
  }

  .mainIconHover {
    stroke: $success-f2g;
  }

  .blueButton {
    color: white;
    background-color: $blue-1-f2g !important;
  }

  .redButton {
    color: white;
    background-color: $red-error !important;
  }

  .buttonHover {
    background-color: grey !important;
  }
  .checkIcon {
    cursor: pointer;
    stroke: $success-f2g;
    transition-duration: 500ms;
    transition-property: background-color;
  }
  .checkIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .cancelIcon {
    cursor: pointer;
    stroke: $red-error;
  }

  .cancelIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .infoIcon:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.v-stepper,
.v-stepper__header {
  box-shadow: none !important;
}
</style>
